'use strict';

var eventInfo = require('../events/event-info.cjs');
var Feature = require('../motion/features/Feature.cjs');
var index = require('../../../../../../motion-dom/dist/es/gestures/press/index.cjs');
var frame = require('../../../../../../motion-dom/dist/es/frameloop/frame.cjs');

function handlePressEvent(node, event, lifecycle) {
    const { props } = node;
    if (node.current instanceof HTMLButtonElement && node.current.disabled) {
        return;
    }
    if (node.animationState && props.whileTap) {
        node.animationState.setActive("whileTap", lifecycle === "Start");
    }
    const eventName = ("onTap" + (lifecycle === "End" ? "" : lifecycle));
    const callback = props[eventName];
    if (callback) {
        frame.frame.postRender(() => callback(event, eventInfo.extractEventInfo(event)));
    }
}
class PressGesture extends Feature.Feature {
    mount() {
        const { current } = this.node;
        if (!current)
            return;
        this.unmount = index.press(current, (_element, startEvent) => {
            handlePressEvent(this.node, startEvent, "Start");
            return (endEvent, { success }) => handlePressEvent(this.node, endEvent, success ? "End" : "Cancel");
        }, { useGlobalTarget: this.node.props.globalTapTarget });
    }
    unmount() { }
}

exports.PressGesture = PressGesture;
//# sourceMappingURL=press.cjs.map
